export default {
  methods: {
    async successNotify() {
      this.$notify({
        title: this.$t("system_success_title"),
        message: this.$t("system_success"),
        type: "success"
      });
    },
    async errorNotify(text) {
      this.$notify({
        title: this.$t("system_error_title"),
        message: text || this.$t("system_error"),
        type: "error"
      });
    }
  }
};
